import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-topic-summary-card',
  templateUrl: './topic-summary-card.component.html',
  styleUrls: ['./topic-summary-card.component.css']
})
export class TopicSummaryCardComponent implements OnInit {

  @Input() topicName: string;
  @Input() flashcardData:any;
  @Input() allTopicsSummeryProgress:any;
  completedCount = 0;
  constructor(public router: Router, public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    this.getTopicSummaryProgress();
  }

  getTopicSummaryProgress(){
    const topic = this.allTopicsSummeryProgress?.filter((element:any) => this.flashcardData.topicId == element.topicId);
    if(topic){this.completedCount = topic[0]?.count || 0}
    // this.selfLearnService.getTopicSummaryProgress().subscribe((resp:any) => {
    //   const topic = resp?.data?.filter((element:any) => this.flashcardData.topicId == element.topicId);
    //   if(topic){this.completedCount = topic[0]?.count || 0}
    // });
  }

  navigateToTopicDetails(){
    localStorage.setItem("selfLearnSelectedTopicId", this.flashcardData.topicId);
    localStorage.setItem("selfLearnSelectedTopicName", this.topicName);
    localStorage.setItem("SelectedFlashcardData", JSON.stringify(this.flashcardData));
    this.router.navigateByUrl("selfLearn-V2/topic-summary-details");
  }

}
